module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell city-cell",
    class: {
      active: _vm.quiz.id === _vm.quizId,
        disabled: _vm.disabled
    },
    on: {
      "click": _vm.selectQuiz
    }
  }, [_vm._v("\n  " + _vm._s(_vm.quiz.name) + "\n  "), _c('div', {
    staticClass: "city-paper"
  }, [_vm._v(_vm._s(_vm.quiz.examTypeName))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54281412"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CityCell.vue
// module id = 474
// module chunks = 1